import React, { useState } from "react";
import {
  formatDateTime,
  TableLoader,
  utcDateTimeToLocalPA,
} from "../../shared";
import { can } from "../../Auth";
import { ActionButton } from "../../components";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Flex,
  message,
  Popconfirm,
  Space,
  Table,
  Typography,
} from "antd";
import { AddEditDraftNotes } from "./AddEditDraftNotes";
import { draftapi } from "../../services/draftapi";

const { Text } = Typography;
const DraftNoteTable = ({ editDraft, notesData, call, isOff }) => {
  const [visible, setVisible] = useState(false);
  const [noteedit, setNoteEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const DeleteDraftNote = async (id) => {
    setDeleting(true);
    const result = await draftapi?.deleteDraftNote(id);

    if (result?.success) {
      message.success("Draft Note deleted successfully");
      call();
    } else {
      message.error(result?.message || "Failed to delete");
    }
    setDeleting(false);
  };

  const columns = [
    {
      title: "Note",
      dataIndex: "notes",
      render: (notes) => {
        return <div dangerouslySetInnerHTML={{ __html: notes }} />;
      },
      width: 400,
    },
    {
      title: "Added At",
      dataIndex: "created_at",
      render: (created_at) => utcDateTimeToLocalPA(created_at),
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => {
        return (
          <>
            <Space>
              {/* {can("Draft", "") && (
                
              )} */}
              <ActionButton
                title="Edit"
                type="primary"
                icon={<EditOutlined />}
                onClick={() => {
                  setVisible(true);
                  setNoteEdit(row);
                }}
              />
              <Popconfirm
                title="Are you sure to delete this note?"
                onConfirm={() => DeleteDraftNote(row?.id)}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ loading: deleting }}
              >
                <ActionButton title="Delete" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          </>
        );
      },
    },
  ];
  return (
    <>
      <Flex vertical gap={10}>
        <Divider />
        <Flex justify="space-between">
          <Text strong>Previous Notes</Text>
          {!isOff ? (
            <Button
              className="fs-12"
              type="primary"
              onClick={() => setVisible(true)}
            >
              Add Note
            </Button>
          ) : null}
        </Flex>
        <Table
          columns={columns}
          dataSource={notesData || []}
          loading={{
            ...TableLoader,
            spinning: loading,
          }}
          pagination={false}
          scroll={{ x: 700 }}
        />
      </Flex>
      <AddEditDraftNotes
        visible={visible}
        editItem={noteedit}
        editDraft={editDraft}
        onClose={() => {
          setVisible(false);
          setNoteEdit(null);
        }}
        call={call}
      />
    </>
  );
};

export { DraftNoteTable };
